// Platform colors matching PlatformIcon.tsx
export const PLATFORM_COLORS = {
  youtube: "#ef4444", // red-500
  instagram: "#ec4899", // pink-500
  tiktok: "hsl(var(--foreground))", // Theme-aware: dark in light mode, light in dark mode
  unknown: "#6B7280",
};

// Get TikTok color based on theme
export const getTikTokColor = () => {
  if (typeof window !== "undefined") {
    const isDark = document.documentElement.classList.contains("dark");
    return isDark ? "#f5f5dc" : "#374151"; // beige for dark mode, dark grey for light mode
  }
  return "#374151"; // default to dark grey
};
